import { render, staticRenderFns } from "./GroupPOIsMenu.vue?vue&type=template&id=625d507e&scoped=true"
import script from "./GroupPOIsMenu.vue?vue&type=script&lang=js"
export * from "./GroupPOIsMenu.vue?vue&type=script&lang=js"
import style0 from "./GroupPOIsMenu.vue?vue&type=style&index=0&id=625d507e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d507e",
  null
  
)

export default component.exports